import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useSelector } from "react-redux";

import uploadTask from "../../api/uploadTask.js";
import { errorWithReason, humanFileSize } from "../../helpers.js";
import Button from "../Button.jsx";
import ListItem from "../ListItem.jsx";
import UploadField from "../UploadField.jsx";
import { DEFAULT_FILE_SIZE, mapExtensions } from "../../uploadHelpers.js";
import Icon from "../Icon.jsx";
import i18n from "../../i18n.js";

export default function PdfUpload({ generalError, info, maxSize, onChange }) {
  const [fileToUpload, setFileToUpload] = useState(null);
  const [error, setError] = useState(null);
  const maxFileSize = maxSize || DEFAULT_FILE_SIZE;

  async function handleChange(file) {
    setError(null);
    if (file.size > maxFileSize) {
      setError(
        i18n.t("component.projects_add.pdf_upload.file_too_large", {
          size: humanFileSize(maxFileSize),
        })
      );
      return false;
    }
    setFileToUpload(file);
    onChange(file);
  }

  async function handleDelete(event) {
    event.preventDefault();
    setFileToUpload(null);
  }

  return (
    <div class="mt-32 mb-32">
      {fileToUpload ? (
        <ListItem
          bordered
          secondLine={humanFileSize(fileToUpload.size)}
          iconFront="pdf_sheet"
          iconBack={
            <Button text onClick={handleDelete} href="#">
              <Icon>delete</Icon>
            </Button>
          }
        >
          {fileToUpload.name}
        </ListItem>
      ) : (
        <UploadField
          dragDrop
          dragDropAllow={["application/pdf"]}
          icon="big_upload_files"
          name="pdf"
          info={info}
          error={generalError || error}
          onChange={handleChange}
          size={maxFileSize}
          accept="application/pdf"
        />
      )}
    </div>
  );
}
